import React, {Component} from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {FaIcon} from "../FaIcon";
import {Spinner} from "../Spinner";
import {Switch} from "../buttons/Swtich";
import {MultiSelect} from "../selects/MultiSelect";
import {AgencyClientSelect} from "../selects/AgencyClientSelect";
import {HELP_ADMIN_AND_REGULAR_USERS, LinkToArticle} from "../help_center/LinkToArticle";
import { withTranslation } from 'react-i18next';

class InviteUserFormClass extends Component {
    constructor(props) {
        super(props);
        const editUser = this.props.editUser;
        if (editUser) {
            this.state = {
                saving: false,
                userType: editUser.user_type || 'Admin',
                canUseMarketingModule: true,
                canUseManageAccountsModule: false,
                moduleMarketingCanAssignClients: editUser.module_marketing_can_assign_clients || false,
                moduleManageAccountsGoogleManagerId: null,
                moduleManageAccountsCanEditManagerAdspentLimit: false,
                moduleManageAccountsCanCreateAdAccounts: false,
                moduleManageAccountsCanGiveAccessToAdAccounts: false,
                agencyClients: null,
                selectedClientIds: (editUser.client_ids || []).map(id => id.toString()),
                loadingClients: false,
                clientFeatures: editUser.client_features || {
                    dashboard: false, data_explorer: false, connect: true, reports: true, insights: false
                }
            };
        } else {
            this.state = {
                saving: false,
                userType: this.props.clientOnly ? 'Client' : (this.props.moduleAccessConfigurationEnabled ? 'Regular' : 'Admin'),
                canUseMarketingModule: true,
                canUseManageAccountsModule: false,
                moduleMarketingCanAssignClients: !this.props.moduleAccessConfigurationEnabled,
                moduleManageAccountsGoogleManagerId: null,
                moduleManageAccountsCanEditManagerAdspentLimit: !this.props.moduleAccessConfigurationEnabled,
                moduleManageAccountsCanCreateAdAccounts: !this.props.moduleAccessConfigurationEnabled,
                moduleManageAccountsCanGiveAccessToAdAccounts: !this.props.moduleAccessConfigurationEnabled,
                agencyClients: null,
                selectedClientIds: this.props.initialSelectedClientIds || [],
                loadingClients: false,
                clientFeatures: {
                    dashboard: false, data_explorer: false, connect: true, reports: true, insights: false
                }
            };
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClientsChange = this.handleClientsChange.bind(this);
        this.handleSingleClientChange = this.handleSingleClientChange.bind(this);
        this.selectUserType = this.selectUserType.bind(this);
    }

    componentDidMount() {
        this.fetchAgencyClients();
    }

    handleSubmit(event) {
        event.preventDefault();
        const { t } = this.props;
        if (this.state.userType === 'Client' && this.state.selectedClientIds.length !== 1) {
            alert(t('invite_user.client_requires_exactly_one'));
            return;
        }
        if (this.props.editUser) {
            this.handleEditSubmit();
        } else {
            this.handleInviteSubmit(event);
        }
    }

    handleInviteSubmit(event) {
        this.setState({saving: true});
        const data = {
            'email': event.target.email.value,
            'user_type': this.state.userType,
            'can_use_marketing_module': true,
            'can_use_manage_accounts_module': false,
            'module_marketing_can_assign_clients': this.state.moduleMarketingCanAssignClients,
            'module_manage_accounts_google_manager_id': this.state.moduleManageAccountsGoogleManagerId,
            'module_manage_accounts_can_edit_manager_adspent_limit': this.state.moduleManageAccountsCanEditManagerAdspentLimit,
            'module_manage_accounts_can_create_ad_accounts': this.state.moduleManageAccountsCanCreateAdAccounts,
            'module_manage_accounts_can_give_access_to_ad_accounts': this.state.moduleManageAccountsCanGiveAccessToAdAccounts,
            'client_ids': this.state.selectedClientIds,
            'client_features': this.state.userType === 'Client' ? this.state.clientFeatures : undefined
        };
        new APIClient(API_URL + 'invitation/send').call('POST', data).then((data) => {
            this.setState({saving: false});
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.props.afterSubmit()
            }
        });
    }

    handleEditSubmit() {
        const userId = this.props.editUser.id;
        this.setState({saving: true});

        const accessData = {
            'user_type': this.state.userType,
            'can_use_marketing_module': true,
            'can_use_manage_accounts_module': false,
            'module_marketing_can_assign_clients': this.state.moduleMarketingCanAssignClients,
        };

        const clientsData = {
            'clients': this.state.selectedClientIds.map(id => parseInt(id)),
        };

        const accessCall = new APIClient(API_URL + `user/${userId}/access`).call('POST', accessData);
        const clientsCall = new APIClient(API_URL + `user/${userId}/module/marketing`).call('POST', clientsData);

        const calls = [accessCall, clientsCall];

        if (this.state.userType === 'Client') {
            const featuresCall = new APIClient(API_URL + `user/${userId}/client-features`).call('POST', {
                client_features: this.state.clientFeatures
            });
            calls.push(featuresCall);
        }

        Promise.all(calls).then((results) => {
            this.setState({saving: false});
            const errorResult = results.find(r => r.status === 'ERROR');
            if (errorResult) {
                alert(errorResult['error_message']);
            } else {
                this.props.afterSubmit();
            }
        });
    }

    selectUserType(type) {
        const previousType = this.state.userType;
        const switchingToOrFromClient = type === 'Client' || previousType === 'Client';
        this.setState({
            userType: type,
            selectedClientIds: switchingToOrFromClient ? [] : this.state.selectedClientIds
        });
    }

    renderSaveButton() {
        const { t } = this.props;
        if (!this.state.saving) {
            const label = this.props.editUser ? t('edit_user.save_button') : t('invite_user.send_button');
            return <input type="submit" value={label} className={this.props.editUser ? "btn -alt" : "btn -submit"}/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    render() {
        const { t } = this.props;
        const isEditMode = !!this.props.editUser;
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        {isEditMode ? (
                            <div style={{marginBottom: '1.2em'}}>
                                <strong>{this.props.editUser.name}</strong>
                                <div style={{fontSize: '0.85em', color: '#999'}}>{this.props.editUser.email}</div>
                            </div>
                        ) : (
                            <div className="form-row">
                                <label>{t('invite_user.email_label')}</label>
                                <input name="email" type="email" required placeholder={t('invite_user.email_placeholder')} />
                            </div>
                        )}

                        <div className="invite-separator" />

                        {this.renderUserTypeCards()}
                        {this.renderTypeOptions()}
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.renderSaveButton()}
                </ModalFooter>
            </form>
        )
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const switchesNames = ["canUseMarketingModule", "canUseManageAccountsModule", "moduleMarketingCanAssignClients",
            "moduleManageAccountsCanEditManagerAdspentLimit",
            "moduleManageAccountsCanCreateAdAccounts",
            "moduleManageAccountsCanGiveAccessToAdAccounts"]
        const value = switchesNames.includes(name) ? target.checked : target.value;

        this.setState({
            ...this.state,
            [name]: value
        });
    }

    fetchAgencyClients() {
        this.setState({loadingClients: true});
        new APIClient(API_URL + 'agency/clients/').call('GET').then((data) => {
            if (data.status === 'OK') {
                this.setState({agencyClients: data.data, loadingClients: false});
            } else {
                this.setState({loadingClients: false});
            }
        });
    }

    handleClientsChange(selectedClientIds) {
        this.setState({selectedClientIds: selectedClientIds});
    }

    handleSingleClientChange(clientId, clientName) {
        this.setState({selectedClientIds: clientId ? [clientId] : []});
    }

    renderClientCardDisabled() {
        const { t } = this.props;
        const limitInfo = this.props.clientUsersLimitInfo;
        const isFeatureOff = limitInfo && limitInfo.max === 0;

        return (
            <div className="invite-type-card -upgrade">
                <div className="invite-type-card-icon">
                    <FaIcon iconName="user-tag"/>
                </div>
                <div className="invite-type-card-content">
                    <span className="invite-type-card-label">{t('invite_user.client_option')}</span>
                    <span className="invite-type-card-desc">{t('invite_user.client_description_short')}</span>
                    <div className="invite-upgrade-info">
                        {isFeatureOff ? (
                            <span className="invite-upgrade-message">{t('invite_user.client_disabled_feature_off')}</span>
                        ) : (
                            <>
                                <span className="invite-upgrade-badge">
                                    {t('invite_user.client_usage', {current: limitInfo?.current || 0, max: limitInfo?.max || 0})}
                                </span>
                                <span className="invite-upgrade-message">{t('invite_user.client_limit_reached')}</span>
                            </>
                        )}
                        <a className="btn -alt invite-upgrade-cta" href="/agency/subscription">
                            <FaIcon iconName="arrow-up-right-from-square"/>
                            {t('invite_user.upgrade_plan_cta')}
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    renderUserTypeCards() {
        const { t } = this.props;
        const types = [];
        if (!this.props.clientOnly) {
            types.push({value: 'Admin', icon: 'user-shield', label: t('invite_user.admin_option'), desc: t('invite_user.admin_description')});
            if (this.props.moduleAccessConfigurationEnabled) {
                types.push({value: 'Regular', icon: 'user', label: t('invite_user.regular_option'), desc: t('invite_user.regular_description')});
            }
        }
        const clientDisabled = this.props.canAddClientUser === false;

        return (
            <div className="form-row" style={{marginBottom: '1em'}}>
                <label>{t('invite_user.user_type_label')}<LinkToArticle article={HELP_ADMIN_AND_REGULAR_USERS} /></label>
                <div className="invite-type-cards">
                    {types.map(type => (
                        <div
                            key={type.value}
                            className={`invite-type-card ${this.state.userType === type.value ? '-selected' : ''}`}
                            onClick={() => this.selectUserType(type.value)}
                        >
                            <div className="invite-type-card-icon">
                                <FaIcon iconName={type.icon}/>
                            </div>
                            <div className="invite-type-card-content">
                                <span className="invite-type-card-label">{type.label}</span>
                                <span className="invite-type-card-desc">{type.desc}</span>
                            </div>
                        </div>
                    ))}
                    {clientDisabled ? this.renderClientCardDisabled() : (
                        <div
                            className={`invite-type-card ${this.state.userType === 'Client' ? '-selected' : ''}`}
                            onClick={() => this.selectUserType('Client')}
                        >
                            <div className="invite-type-card-icon">
                                <FaIcon iconName="user-tag"/>
                            </div>
                            <div className="invite-type-card-content">
                                <span className="invite-type-card-label">{t('invite_user.client_option')}</span>
                                <span className="invite-type-card-desc">{t('invite_user.client_description_short')}</span>
                            </div>
                        </div>
                    )}
                </div>
                {this.state.userType === 'Regular' && this.props.moduleAccessConfigurationEnabled && (
                    <div className="invite-card-expand">
                        <label style={{marginBottom: 0}}>{t('invite_user.can_modify_clients')}</label>
                        <Switch onChange={this.handleChange}
                                checked={this.state.moduleMarketingCanAssignClients}
                                name="moduleMarketingCanAssignClients"
                                messageToAlertUserIfChecked={null}
                        />
                    </div>
                )}
            </div>
        );
    }

    handleFeatureToggle(featureKey, checked) {
        this.setState({
            clientFeatures: {
                ...this.state.clientFeatures,
                [featureKey]: checked
            }
        });
    }

    renderClientFeatureToggles() {
        const { t } = this.props;
        const features = [
            { key: 'connect', icon: 'microchip', available: true },
            { key: 'reports', icon: 'wand-magic-sparkles', available: true },
            { key: 'dashboard', icon: 'chart-line', available: false },
            { key: 'data_explorer', icon: 'binoculars', available: false },
            { key: 'insights', icon: 'star', available: false },
        ];

        return (
            <div className="invite-client-features">
                <label>{t('invite_user.client_features_label')}</label>
                {features.map(feature => (
                    <div key={feature.key} className={`invite-feature-row ${!feature.available ? '-coming-soon' : ''}`}>
                        <div className="invite-feature-info">
                            <FaIcon iconName={feature.icon} className="invite-feature-icon"/>
                            <div className="invite-feature-text">
                                <span className="invite-feature-name">{t(`invite_user.feature_${feature.key}`)}</span>
                                <span className="invite-feature-desc">
                                    {feature.available ? t(`invite_user.feature_${feature.key}_desc`) : t('invite_user.coming_soon_desc')}
                                </span>
                            </div>
                        </div>
                        {feature.available ? (
                            <Switch
                                name={`feature_${feature.key}`}
                                checked={this.state.clientFeatures[feature.key]}
                                onChange={(e) => this.handleFeatureToggle(feature.key, e.target.checked)}
                                style={{margin: 0}}
                            />
                        ) : (
                            <span className="invite-feature-badge-coming-soon">{t('invite_user.coming_soon')}</span>
                        )}
                    </div>
                ))}
            </div>
        );
    }

    canUserModifyClients() {
        return this.state.userType === 'Admin' ||
            (this.state.userType === 'Regular' && this.state.moduleMarketingCanAssignClients);
    }

    renderTypeOptions() {
        const { t } = this.props;
        const isClientType = this.state.userType === 'Client';

        return (
            <div key="client-options" className="invite-client-section">
                {isClientType && (
                    <div className="invite-info-callout">
                        <FaIcon iconName="info-circle" className="invite-info-callout-icon"/>
                        <span>{t('invite_user.client_user_description')}</span>
                    </div>
                )}
                {isClientType && this.state.selectedClientIds.length === 1 && (
                    <a
                        className="invite-preview-link"
                        href={`/client/${this.state.selectedClientIds[0]}/preview`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FaIcon iconName="eye"/>
                        {t('preview.invite_link')}
                    </a>
                )}
                <div className="form-row" style={{marginBottom: 0}}>
                    <label>{isClientType ? t('invite_user.assign_client_singular_label') : t('invite_user.assign_clients_label')}</label>
                    {!isClientType && this.canUserModifyClients() && (
                        <span className="invite-hint">{t('invite_user.assign_clients_preselection_hint')}</span>
                    )}
                    {this.state.loadingClients ? (
                        <div style={{padding: '1.5em 0', textAlign: 'center'}}><Spinner color="positive small"/></div>
                    ) : this.state.agencyClients !== null ? (
                        isClientType ? (
                            <AgencyClientSelect
                                allAgencyClients={this.state.agencyClients}
                                selectedAgencyClient={this.state.selectedClientIds.length > 0 ? parseInt(this.state.selectedClientIds[0]) : null}
                                onAgencyClientChange={this.handleSingleClientChange}
                            />
                        ) : (
                            <MultiSelect
                                showOnlyActiveCheck={true}
                                items={this.state.agencyClients}
                                selectedItemIds={this.state.selectedClientIds}
                                onChange={this.handleClientsChange}
                                itemDataMap={(item) => ({name: item.name, id: item.id.toString(), isActive: item.active})}
                            />
                        )
                    ) : null}
                </div>
                {isClientType && this.renderClientFeatureToggles()}
            </div>
        );
    }
}

class InviteUserModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
        this.afterSubmit = this.afterSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSubmit() {
        this.toggle();
        this.props.onUserInvited();
    }

    render() {
        const { t } = this.props;
        const buttonText = this.props.buttonText || t('invite_user.invite_button');
        const buttonClassName = `btn -alt${this.props.iconOnly ? ' -icon-only' : ''}`;
        return (
            <div>
                <Button
                    className={buttonClassName}
                    onClick={this.toggle}
                    aria-label={buttonText}
                    title={buttonText}
                >
                    <FaIcon iconName="user-plus"/>
                    {!this.props.iconOnly && buttonText}
                </Button>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}><FaIcon iconName="user-plus"/>{t('invite_user.modal_title')}</ModalHeader>
                    <InviteUserForm closeModal={this.toggle} afterSubmit={this.afterSubmit}
                                    moduleAccessConfigurationEnabled={this.props.moduleAccessConfigurationEnabled}
                                    canAddClientUser={this.props.canAddClientUser}
                                    clientUsersLimitInfo={this.props.clientUsersLimitInfo}
                                    clientOnly={this.props.clientOnly}
                                    isSuperAdmin={this.props.isSuperAdmin}
                                    initialSelectedClientIds={this.props.initialSelectedClientIds}/>
                </Modal>
            </div>
        );
    }
}

class EditUserModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
        this.toggle = this.toggle.bind(this);
        this.afterSubmit = this.afterSubmit.bind(this);
    }

    toggle() {
        this.setState({modal: !this.state.modal});
    }

    afterSubmit() {
        this.toggle();
        if (this.props.onSaved) this.props.onSaved();
    }

    render() {
        const { t, user } = this.props;
        return (
            <>
                <a onClick={this.toggle} style={{cursor: 'pointer'}} title={t('edit_user.edit_button_title')}>
                    <FaIcon iconName="user-edit"/>
                </a>
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <FaIcon iconName="user-edit"/>
                        {t('edit_user.modal_title')}
                    </ModalHeader>
                    <InviteUserForm
                        closeModal={this.toggle}
                        afterSubmit={this.afterSubmit}
                        editUser={user}
                        moduleAccessConfigurationEnabled={this.props.moduleAccessConfigurationEnabled}
                        canAddClientUser={this.props.canAddClientUser}
                        isSuperAdmin={this.props.isSuperAdmin}
                    />
                </Modal>
            </>
        );
    }
}

export const InviteUserForm = withTranslation()(InviteUserFormClass);
export const InviteUserModal = withTranslation()(InviteUserModalClass);
export const EditUserModalInline = withTranslation()(EditUserModalClass);
